var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGenerator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.518 17.25a3.518 3.518 0 1 1 0-7.035 3.518 3.518 0 0 1 0 7.035m0-5.91a2.393 2.393 0 1 0 2.392 2.392 2.39 2.39 0 0 0-2.392-2.422z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.438 14.25H6.48a.562.562 0 1 1 0-1.125h10.395v-6.42a4.815 4.815 0 0 0-4.815-4.8H5.933a4.77 4.77 0 0 0-4.793 4.59q.006.045 0 .09a1 1 0 0 0 0 .12v6.998a.563.563 0 1 1-1.125 0V6.705a2 2 0 0 1 0-.285A5.88 5.88 0 0 1 5.933.75h6.127A5.933 5.933 0 0 1 18 6.705v6.998a.57.57 0 0 1-.562.547"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.3 7.035H.563a.563.563 0 0 1 0-1.125H6.3a.563.563 0 1 1 0 1.125M10.5 11.355a.563.563 0 0 1-.465-.855l1.402-2.43H9.885a.56.56 0 0 1-.488-.277.54.54 0 0 1 0-.563l1.89-3.27a.56.56 0 0 1 .75-.202.555.555 0 0 1 .203.75l-1.38 2.445h1.552a.56.56 0 0 1 .488.285.54.54 0 0 1 0 .562l-1.89 3.27a.57.57 0 0 1-.51.285M15.428 17.25a.555.555 0 0 1-.563-.562v-2.985a.562.562 0 1 1 1.125 0v2.955a.564.564 0 0 1-.562.593"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export default SvgGenerator;